// react and js
import { React, useContext, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

// mui
import { Grid, Container } from "@mui/material";

// components
import Page from "../../components/Page";

// hooks
import appContext from "../../hooks/appContext";
// layouts

// pages

// theme

// utils

// widgets
import WidgetSubscriptions from "../../widgets/subscriptions/SubscriptionsCombined";

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function Subscriptions() {
  // eslint-disable-next-line
  const { stateStorage, setStateStorage } = useContext(appContext);
  const { t } = useTranslation();

  // ######################################################
  // Scroll to top on mount
  // ######################################################
  useEffect(() => {
    const autoScrollContainer = document.querySelector(
      "#auto-scroll-container"
    );
    if (autoScrollContainer !== null) {
      autoScrollContainer.scrollTo({
        top: 0,
        behavior: "instant",
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ######################################################
  // Main outlet
  // ######################################################

  // eslint-disable-next-line
  return useMemo(() => {
    return (
      <Page title={t("pages.subscriptions.title")}>
        <Container maxWidth="false">
          <Grid container spacing={3}>
            <WidgetSubscriptions />
          </Grid>
        </Container>
      </Page>
    );
  }, [t]);
}
